import loadable from '@loadable/component';

const NavbarLoadable = loadable(() => import(/* webpackChunkName: "navbar-component" */ './index'));

export default NavbarLoadable;
